<div class="ui-g">
  <div class="ui-g-12">
    <p-toast></p-toast>
    <div class="card pfieldset-egd-theme-border">
      <p-header class="pheader">Current Medical Problems</p-header>
      <div class="ui-g form-group">
        <div class="ui-g-12">
          <div class="ui-g-12">
            <label for="condition_description">Describe in detail about your current medical problem
              <span class="req red-req">*</span>:</label>
          </div>
          <div class="ui-g-12">
            <div class="ui-g-12">
              <textarea [(ngModel)]="
                  this.medicalHistoryUiEdit_data.others.data
                    .currentMedicalProblems
                " class="WordWrap format-lines patient-medical-upload-textarea" name="condition_description"
                id="condition_description" [pKeyFilter]="textarea"
                placeholder="Enter your current medical problems here" maxlength="1000" pInputTextarea
                #details="ngModel" required></textarea>
              <div *ngIf="details.invalid && (details.dirty || details.touched)" class="alert alert-danger">
                <div *ngIf="details.errors.required" class="invalid">
                  Describing your current medical problem is mandatory.
                </div>
              </div>
            </div>
            <div class="ui-g-12">
              <p [style.color]="
                  this.medicalHistoryUiEdit_data.others.data
                    .currentMedicalProblems.length -
                    999 >
                  0
                    ? 'red'
                    : 'green'
                ">
                {{
                1001 -
                this.medicalHistoryUiEdit_data.others.data
                .currentMedicalProblems.length < 0 ? 0 : 1000 - this.medicalHistoryUiEdit_data.others.data
                  .currentMedicalProblems.length }} of 1000 characters left </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card pfieldset-egd-theme-border">
      <p-header class="pheader">Past Medical History</p-header>
      <div>
        <div class="ui-g">
          <div class="ui-g-12">
            <div *ngFor="
                let med_hist of this.medicalHistoryUiEdit_data.others.data
                  .past_medical_history_data
              " class="past-medical-history-item ui-g-12 ui-md-6 ui-lg-4">
              <p-checkbox [(ngModel)]="med_hist.selected" [binary]="true" [label]="med_hist.name" [disabled]="
                  this.medicalHistoryUiEdit_data.others
                    .none_selected_medical_history
                ">
              </p-checkbox>
            </div>
          </div>

          <div class="ui-g-12">
            <div class="past-medical-history-item ui-g-12 ui-md-6 ui-lg-4">
              <p-checkbox [(ngModel)]="this.medicalHistoryUiEdit_data.others.more_medical" [binary]="true" label="Other"
                [disabled]="
                  this.medicalHistoryUiEdit_data.others
                    .none_selected_medical_history
                ">
              </p-checkbox>
            </div>

            <div class="past-medical-history-item ui-g-12 ui-md-6 ui-lg-4">
              <p-checkbox [(ngModel)]="
                  this.medicalHistoryUiEdit_data.others
                    .none_selected_medical_history
                " label="None of the Above" [binary]="true" [value]="
                  this.medicalHistoryUiEdit_data.others
                    .none_selected_medical_history
                " (click)="disableAll()">
              </p-checkbox>
            </div>
          </div>

          <div class="ui-g-12" *ngIf="this.medicalHistoryUiEdit_data.others.more_medical">
            <input type="text" [pKeyFilter]="name_input" pInputText placeholder="Add Medical History" [(ngModel)]="
                this.medicalHistoryUiEdit_data.others.medical_history_value
              " [value]="
                this.medicalHistoryUiEdit_data.others.medical_history_value
              " class="add-more-medical-history-input" />
            <br />
            <br />

            <p-button (click)="addMedicalHistory()" icon="pi pi-plus" label="Add a Medical History">
            </p-button>
          </div>
        </div>
      </div>
    </div>
    <div class="card pfieldset-egd-theme-border">
      <p-header class="pheader">Past Surgical History</p-header>
      <div class="ui-g">
        <div class="ui-g form-group">
          <div class="ui-g-12 ui-md-12">
            <div class="ui-g-12">
              <div class="ui-g-12">
                <textarea [(ngModel)]="
                    this.medicalHistoryUiEdit_data.others.data
                      .past_surgical_history_data
                  " class="WordWrap format-lines patient-medical-upload-textarea" name="past_surgical_history"
                  id="past_surgical_history" [pKeyFilter]="textarea" placeholder="Enter your past surgical history here"
                  maxlength="1000" pInputTextarea #details="ngModel" style="height: 70px"></textarea>
              </div>
              <div class="ui-g-12 float-left">
                <p [style.color]="
                    this.medicalHistoryUiEdit_data.others.data
                      .past_surgical_history_data.length -
                      999 >
                    0
                      ? 'red'
                      : 'green'
                  " class="float-left">
                  {{
                  1001 -
                  this.medicalHistoryUiEdit_data.others.data
                  .past_surgical_history_data.length < 0 ? 0 : 1000 - this.medicalHistoryUiEdit_data.others.data
                    .past_surgical_history_data.length }} of 1000 characters left </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card pfieldset-egd-theme-border">
      <p-header class="pheader">Medications</p-header>
      <div>
        <div class="ui-g">
          <div class="ui-g-12">
            <div class="card no-margin">
              <div class="ui-g">
                <div class="ui-g form-group">
                  <div class="ui-g-12 ui-md-4">
                    <label for="Medication_Name">Medication Name<span class="red-req">*</span></label>
                  </div>
                  <div class="ui-g-12 ui-md-8">
                    <input id="Medication_Name" [pKeyFilter]="medication_name_input" type="text"
                      style="width: 155px; border-color: rgb(16, 151, 16)" pInputText [value]="
                        this.medicalHistoryUiEdit_data.others
                          .add_temp_medication.name
                      " [(ngModel)]="
                        this.medicalHistoryUiEdit_data.others
                          .add_temp_medication.name
                      " placeholder="Name" required />
                  </div>
                  <div class="ui-g-12 ui-md-4">
                    <label for="Dose">Dose in (mg &#47; ml)<span class="red-req">*</span></label>
                  </div>
                  <div class="ui-g-12 ui-md-8">
                    <input id="Dose" type="text" [pKeyFilter]="dose_input"
                      style="width: 155px; border-color: rgb(16, 151, 16)" pInputText [value]="
                        this.medicalHistoryUiEdit_data.others
                          .add_temp_medication.dose
                      " [(ngModel)]="
                        this.medicalHistoryUiEdit_data.others
                          .add_temp_medication.dose
                      " placeholder="Dose" required />
                  </div>
                  <div class="ui-g-12 ui-md-4">
                    <label for="Times_per_day">Times Per Day</label>
                  </div>
                  <div class="ui-g-12 ui-md-8">
                    <input id="Times_per_day" type="text" [pKeyFilter]="number_input"
                      style="width: 155px; border-color: rgb(16, 151, 16)" pInputText [value]="
                        this.medicalHistoryUiEdit_data.others
                          .add_temp_medication.times_per_day
                      " [(ngModel)]="
                        this.medicalHistoryUiEdit_data.others
                          .add_temp_medication.times_per_day
                      " placeholder="Times Per Day" required />
                  </div>
                  <div class="ui-g-12 ui-md-4">
                    <label for="Times_per_day">Instructions</label>
                  </div>
                  <div class="ui-g-12 ui-md-8">
                    <input id="Times_per_day" type="text" [pKeyFilter]="blockSpecialCharachters"
                      style="width: 155px; border-color: rgb(16, 151, 16)" pInputText [value]="
                        this.medicalHistoryUiEdit_data.others
                          .add_temp_medication.instructions
                      " [(ngModel)]="
                        this.medicalHistoryUiEdit_data.others
                          .add_temp_medication.instructions
                      " placeholder="Instructions" required />
                  </div>
                  <div class="ui-g-12 ui-md-4"></div>
                  <div class="ui-g-12 ui-md-8">
                    <button pButton type="button" class="ui-button-success" label="Save" icon="pi pi-plus"
                      (click)="addData('medication')" [disabled]="
                        this.medicalHistoryUiEdit_data.others
                          .add_temp_medication.name.length == 0 ||
                        this.medicalHistoryUiEdit_data.others
                          .add_temp_medication.dose.length == 0
                      "></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card no-margin">
          <div class="table-responsive text-center justify-content-center">
            <p-table #dt2 [columns]="
                this.medicalHistoryUiEdit_data.others.medication_columns
              " styleClass="p-datatable-customers" dataKey="id"
              [value]="this.medicalHistoryUiEdit_data.others.data.medications" [rows]="5" [paginator]="true"
              [rowsPerPageOptions]="[10, 25, 50]" [scrollable]="true"
              [globalFilterFields]="['name', 'dose', 'times_per_day']"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
              <ng-template pTemplate="caption">
                <div class="table-header">
                  <span class="p-input-icon-left table-search-span">
                    <input pInputText type="text" (input)="
                        dt2.filterGlobal($event.target.value, 'contains')
                      " placeholder="Search" class="table-search search-bar" />
                  </span>
                </div>
              </ng-template>
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th pSortableColumn="id">
                    Sr No <p-sortIcon field="id"> </p-sortIcon>
                  </th>
                  <th pSortableColumn="name">
                    Medication Name <p-sortIcon field="name"> </p-sortIcon>
                  </th>
                  <th pSortableColumn="dose">
                    Dose in (mg &#47; ml)
                    <p-sortIcon field="dose"> </p-sortIcon>
                  </th>
                  <th pSortableColumn="times_per_day">
                    Times Per Day<p-sortIcon field="times_per_day">
                    </p-sortIcon>
                  </th>
                  <th pSortableColumn="instructions">
                    Instructions<p-sortIcon field="instructions"> </p-sortIcon>
                  </th>
                  <th pSortableColumn="">
                    <i class="pi pi-cog"></i>
                    <p-sortIcon field=""> </p-sortIcon>
                  </th>
                  <th pSortableColumn="">
                    <i class="pi pi-cog"></i>
                    <p-sortIcon field=""> </p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-medication>
                <tr [pSelectableRow]="medication">
                  <td>{{ medication.id }}</td>
                  <td>
                    <input type="text" pInputText *ngIf="
                        this.medicalHistoryUiEdit_data.others
                          .medication_edit_id == medication.id
                      " [pKeyFilter]="medication_name_input" [value]="medication.name" [(ngModel)]="medication.name" />
                    <span *ngIf="
                        this.medicalHistoryUiEdit_data.others
                          .medication_edit_id != medication.id
                      ">{{ medication.name }}</span>
                  </td>
                  <td>
                    <input type="text" [pKeyFilter]="dose_input" pInputText *ngIf="
                        this.medicalHistoryUiEdit_data.others
                          .medication_edit_id == medication.id
                      " [value]="medication.dose" [(ngModel)]="medication.dose" />
                    <span *ngIf="
                        this.medicalHistoryUiEdit_data.others
                          .medication_edit_id != medication.id
                      ">
                      {{ medication.dose }}</span>
                  </td>
                  <td>
                    <input type="text" [pKeyFilter]="number_input" pInputText *ngIf="
                        this.medicalHistoryUiEdit_data.others
                          .medication_edit_id == medication.id
                      " [value]="medication.times_per_day" [(ngModel)]="medication.times_per_day" />
                    <span *ngIf="
                        this.medicalHistoryUiEdit_data.others
                          .medication_edit_id != medication.id
                      ">{{ medication.times_per_day }}</span>
                  </td>
                  <td>
                    <input type="text" [pKeyFilter]="blockSpecialCharachters" pInputText *ngIf="
                        this.medicalHistoryUiEdit_data.others
                          .medication_edit_id == medication.id
                      " [value]="medication.instructions" [(ngModel)]="medication.instructions" />
                    <span *ngIf="
                        this.medicalHistoryUiEdit_data.others
                          .medication_edit_id != medication.id
                      ">{{ medication.instructions }}</span>
                  </td>
                  <td>
                    <div *ngIf="
                        this.medicalHistoryUiEdit_data.others
                          .medication_edit_id != medication.id
                      ">
                      <button pButton type="button" class="ui-button-warning" icon="pi pi-pencil"
                        (click)="editData(medication, 'medication')"></button>
                      <button pButton type="button" class="ui-button-danger" icon="pi pi-trash" (click)="
                          confirmDelete($event, 'medication', medication)
                        "></button>
                    </div>
                    <div *ngIf="
                        this.medicalHistoryUiEdit_data.others
                          .medication_edit_id == medication.id
                      ">
                      N/A
                    </div>
                  </td>
                  <td>
                    <div *ngIf="
                        this.medicalHistoryUiEdit_data.others
                          .medication_edit_id == medication.id
                      ">
                      <button pButton type="button" class="ui-button-danger" icon="pi pi-times"
                        (click)="canceleditData(medication, 'medication')"></button>
                      <button pButton type="button" class="ui-button-success" icon="pi pi-save"
                        (click)="saveData(medication, 'medication')" [disabled]="
                          medication.name.length == 0 ||
                          medication.dose.length == 0
                        "></button>
                    </div>
                    <div *ngIf="
                        this.medicalHistoryUiEdit_data.others
                          .medication_edit_id != medication.id
                      ">
                      N/A
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="6">No Data found.</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
    <div class="card pfieldset-egd-theme-border">
      <p-header class="pheader">Allergies</p-header>
      <div>
        <div class="ui-g">
          <div class="ui-g-12">
            <div class="card no-margin">
              <div class="ui-g">
                <div class="ui-g form-group">
                  <div class="ui-g-12 ui-md-4">
                    <label for="Allergy_Name">Allergy Name<span class="red-req">*</span></label>
                  </div>
                  <div class="ui-g-12 ui-md-8">
                    <input id="Allergy_Name" [pKeyFilter]="name_input" type="text"
                      style="width: 155px; border-color: rgb(16, 151, 16)" pInputText [value]="
                        this.medicalHistoryUiEdit_data.others.add_temp_allergy
                          .name
                      " [(ngModel)]="
                        this.medicalHistoryUiEdit_data.others.add_temp_allergy
                          .name
                      " placeholder="Allergy Name" required />
                  </div>
                  <div class="ui-g-12 ui-md-4">
                    <label for="reaction">Allergic Reaction<span class="red-req">*</span></label>
                  </div>
                  <div class="ui-g-12 ui-md-8">
                    <input id="reaction" [pKeyFilter]="name_input" type="text"
                      style="width: 155px; border-color: rgb(16, 151, 16)" pInputText [value]="
                        this.medicalHistoryUiEdit_data.others.add_temp_allergy
                          .reaction
                      " [(ngModel)]="
                        this.medicalHistoryUiEdit_data.others.add_temp_allergy
                          .reaction
                      " placeholder="Allergic Reaction" required />
                  </div>
                  <div class="ui-g-12 ui-md-4"></div>
                  <div class="ui-g-12 ui-md-8">
                    <button pButton type="button" class="ui-button-success" label="Save" icon="pi pi-plus"
                      (click)="addData('allergy')" [disabled]="
                        this.medicalHistoryUiEdit_data.others.add_temp_allergy
                          .name.length == 0 ||
                        this.medicalHistoryUiEdit_data.others.add_temp_allergy
                          .reaction.length == 0
                      "></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <p-table #dt1 [columns]="this.medicalHistoryUiEdit_data.others.allergy_columns"
          styleClass="p-datatable-customers" [value]="this.medicalHistoryUiEdit_data.others.data.allergies" [rows]="5"
          [paginator]="true" [rowsPerPageOptions]="[10, 25, 50]" [scrollable]="true"
          [globalFilterFields]="['name', 'reaction']"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
          <ng-template pTemplate="caption">
            <div class="table-header">
              <span class="p-input-icon-left table-search-span">
                <input pInputText type="text" (input)="dt1.filterGlobal($event.target.value, 'contains')"
                  placeholder="Search" class="table-search search-bar" />
              </span>
            </div>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th pSortableColumn="id">
                Sr No <p-sortIcon field="id"> </p-sortIcon>
              </th>
              <th pSortableColumn="name">
                Allergy Name <p-sortIcon field="name"></p-sortIcon>
              </th>
              <th pSortableColumn="reaction">
                Allergic Reaction <p-sortIcon field="reaction"> </p-sortIcon>
              </th>
              <th pSortableColumn="">
                <i class="pi pi-cog"></i>
                <p-sortIcon field="id"> </p-sortIcon>
              </th>
              <th pSortableColumn="">
                <i class="pi pi-cog"></i>
                <p-sortIcon field="id"> </p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-allergy>
            <tr>
              <td>{{ allergy.id }}</td>
              <td>
                <input type="text" pInputText *ngIf="
                    this.medicalHistoryUiEdit_data.others.allergy_edit_id ==
                    allergy.id
                  " [pKeyFilter]="name_input" [value]="allergy.name" [(ngModel)]="allergy.name" style="width: 100%" />
                <span *ngIf="
                    this.medicalHistoryUiEdit_data.others.allergy_edit_id !=
                    allergy.id
                  ">{{ allergy.name }}</span>
              </td>
              <td>
                <input type="text" pInputText *ngIf="
                    this.medicalHistoryUiEdit_data.others.allergy_edit_id ==
                    allergy.id
                  " [pKeyFilter]="name_input" [value]="allergy.reaction" [(ngModel)]="allergy.reaction"
                  style="width: 100%" />
                <span *ngIf="
                    this.medicalHistoryUiEdit_data.others.allergy_edit_id !=
                    allergy.id
                  ">
                  {{ allergy.reaction }}
                </span>
              </td>
              <td>
                <div *ngIf="
                    this.medicalHistoryUiEdit_data.others.allergy_edit_id !=
                    allergy.id
                  ">
                  <button pButton type="button" class="ui-button-warning" icon="pi pi-pencil"
                    (click)="editData(allergy, 'allergy')"></button>
                  <button pButton type="button" class="ui-button-danger" icon="pi pi-trash"
                    (click)="confirmDelete($event, 'allergy', allergy)"></button>
                </div>
                <div *ngIf="
                    this.medicalHistoryUiEdit_data.others.allergy_edit_id ==
                    allergy.id
                  ">
                  N/A
                </div>
              </td>
              <td>
                <div *ngIf="
                    this.medicalHistoryUiEdit_data.others.allergy_edit_id ==
                    allergy.id
                  ">
                  <button pButton type="button" class="ui-button-danger" icon="pi pi-times"
                    (click)="canceleditData(allergy, 'allergy')"></button>
                  <button pButton type="button" class="ui-button-success" icon="pi pi-save"
                    (click)="saveData(allergy, 'allergy')" [disabled]="
                      allergy.name.length == 0 || allergy.reaction.length == 0
                    "></button>
                </div>
                <div *ngIf="
                    this.medicalHistoryUiEdit_data.others.allergy_edit_id !=
                    allergy.id
                  ">
                  N/A
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="4">No Data found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <p-confirmDialog key="confirm-delete" acceptLabel="Yes" rejectLabel="No">
    </p-confirmDialog>

    <div class="card pfieldset-egd-theme-border">
      <p class="pheader">Social History</p>
      <div class="ui-g">
        <div class="ui-g-12">
          <div class="ui-g-12">
            <div class="ui-g-12">Smoking:</div>
            <div class="ui-g-4 ui-sm-12">
              <p-radioButton id="Yes" value="Yes" label="Yes" [(ngModel)]="
                  this.medicalHistoryUiEdit_data.others.data.social_history
                    .smoking.selected
                " (ngModelChange)="onSocialHistoryChange('smoking')" name="smoking_type_name"
                #smoking_type_name="ngModel" required>
              </p-radioButton>
            </div>
            <div class="ui-g-4 ui-sm-12">
              <p-radioButton id="Not Currently" value="Not Currently" label="Not Currently" [(ngModel)]="
                  this.medicalHistoryUiEdit_data.others.data.social_history
                    .smoking.selected
                " (ngModelChange)="onSocialHistoryChange('smoking')" name="smoking_type_name"
                #smoking_type_name="ngModel" required>
              </p-radioButton>
            </div>
            <div class="ui-g-4 ui-sm-12">
              <p-radioButton id="Never" value="Never" label="Never" [(ngModel)]="
                  this.medicalHistoryUiEdit_data.others.data.social_history
                    .smoking.selected
                " (ngModelChange)="onSocialHistoryChange('smoking')" name="smoking_type_name"
                #smoking_type_name="ngModel" required>
              </p-radioButton>
            </div>
          </div>
          <div *ngIf="
              smoking_type_name.invalid &&
              (smoking_type_name.dirty || smoking_type_name.touched)
            " class="ui-g-12 alert alert-danger">
            <div *ngIf="smoking_type_name.errors.required" class="invalid">
              Selecting a smoking type is required
            </div>
          </div>
          <div class="ui-g-12">
            <ng-container *ngIf="
                this.medicalHistoryUiEdit_data.others.data.social_history
                  .smoking.selected == 'Yes'
              ">
              <div>
                <div class="ui-g-12">Number of Packs per day:</div>
                <div class="ui-g-12">
                  <input type="text" [pKeyFilter]="number_input" style="width: 155px" pInputText #packs="ngModel"
                    [(ngModel)]="
                      this.medicalHistoryUiEdit_data.others.data.social_history
                        .smoking.data.number_of_packs_per_day
                    " required />
                  <div *ngIf="packs.invalid && (packs.dirty || packs.touched)" class="alert alert-danger red-req">
                    <div *ngIf="packs.errors.required" class="invalid">
                      Required
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="ui-g-12">Number of years smoked:</div>
                <div class="ui-g-12">
                  <input type="text" style="width: 155px" [pKeyFilter]="number_input" pInputText #no_of_years="ngModel"
                    [(ngModel)]="
                      this.medicalHistoryUiEdit_data.others.data.social_history
                        .smoking.data.numbers_of_years_smoked
                    " required />
                  <div *ngIf="
                      no_of_years.invalid &&
                      (no_of_years.dirty || no_of_years.touched)
                    " class="alert alert-danger red-req">
                    <div *ngIf="no_of_years.errors.required" class="invalid">
                      Required
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="
                this.medicalHistoryUiEdit_data.others.data.social_history
                  .smoking.selected == 'Not Currently'
              ">
              <div class="ui-g-12">Year of quitting:</div>
              <div class="ui-g-12">
                <p-dropdown id="year" [options]="this.medicalHistoryUiEdit_data.others.years" placeholder="Select"
                  filter="true" scrollHeight="100px" [showClear]="true" [style]="{ width: '155px' }"
                  #quit_years_smoking="ngModel" [(ngModel)]="
                    this.medicalHistoryUiEdit_data.others.data.social_history
                      .smoking.data.year_of_quitting
                  " required></p-dropdown>
                <div *ngIf="
                    quit_years_smoking.invalid &&
                    (quit_years_smoking.dirty || quit_years_smoking.touched)
                  " class="alert alert-danger red-req">
                  <div *ngIf="quit_years_smoking.errors.required" class="invalid">
                    Required
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-12">
            <div class="ui-g-12">Alcohol:</div>
            <div class="ui-g-4 ui-sm-12">
              <p-radioButton id="Yes" value="Yes" label="Yes" [(ngModel)]="
                  this.medicalHistoryUiEdit_data.others.data.social_history
                    .alcohol.selected
                " (ngModelChange)="this.onSocialHistoryChange('alcohol')" name="alcohol_type_name"
                #alcohol_type_name="ngModel" required>
              </p-radioButton>
            </div>
            <div class="ui-g-4 ui-sm-12">
              <p-radioButton id="Not Currently" value="Not Currently" label="Not Currently" [(ngModel)]="
                  this.medicalHistoryUiEdit_data.others.data.social_history
                    .alcohol.selected
                " (ngModelChange)="this.onSocialHistoryChange('alcohol')" name="alcohol_type_name"
                #alcohol_type_name="ngModel" required>
              </p-radioButton>
            </div>
            <div class="ui-g-4 ui-sm-12">
              <p-radioButton id="Never" value="Never" label="Never" [(ngModel)]="
                  this.medicalHistoryUiEdit_data.others.data.social_history
                    .alcohol.selected
                " (ngModelChange)="this.onSocialHistoryChange('alcohol')" name="alcohol_type_name"
                #alcohol_type_name="ngModel" required>
              </p-radioButton>
            </div>
          </div>
          <div *ngIf="
              alcohol_type_name.invalid &&
              (alcohol_type_name.dirty || alcohol_type_name.touched)
            " class="ui-g-12 alert alert-danger">
            <div *ngIf="alcohol_type_name.errors.required" class="invalid">
              Selecting a alcohol type is required
            </div>
          </div>
        </div>
        <div class="ui-g-12">
          <ng-container *ngIf="
              this.medicalHistoryUiEdit_data.others.data.social_history.alcohol
                .selected == 'Yes'
            ">
            <div class="ui-g-12">How many drinks per week:</div>
            <div class="ui-g-12">
              <input type="text" style="width: 155px" [pKeyFilter]="number_input" pInputText #drinks="ngModel"
                [(ngModel)]="
                  this.medicalHistoryUiEdit_data.others.data.social_history
                    .alcohol.data.drinks_per_week
                " required />
              <div *ngIf="drinks.invalid && (drinks.dirty || drinks.touched)" class="alert alert-danger red-req">
                <div *ngIf="drinks.errors.required" class="invalid">
                  Required
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="
              this.medicalHistoryUiEdit_data.others.data.social_history.alcohol
                .selected == 'Not Currently'
            ">
            <div class="ui-g-12">Year of quitting:</div>
            <div class="ui-g-12">
              <p-dropdown id="year" [options]="this.medicalHistoryUiEdit_data.others.years" placeholder="Select"
                filter="true" scrollHeight="100px" [showClear]="true" [style]="{ width: '155px' }"
                #quit_years_alcohol="ngModel" [(ngModel)]="
                  this.medicalHistoryUiEdit_data.others.data.social_history
                    .alcohol.data.year_of_quitting
                " required></p-dropdown>
              <div *ngIf="
                  quit_years_alcohol.invalid &&
                  (quit_years_alcohol.dirty || quit_years_alcohol.touched)
                " class="alert alert-danger red-req">
                <div *ngIf="quit_years_alcohol.errors.required" class="invalid">
                  Required
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="card pfieldset-egd-theme-border">
      <p class="pheader">Family History</p>
      <div class="ui-g">
        <div class="ui-g-12 row" *ngFor="
            let family of this.medicalHistoryUiEdit_data.others.data
              .family_history
          ">
          <div class="ui-g-3 ui-sm-12">
            <p class="cust-select">{{ family.name }}</p>
          </div>
          <div class="ui-g-9 ui-sm-12">
            <p-multiSelect class="notranslate" [options]="this.medicalHistoryUiEdit_data.others.data.other_data.family_history_options_data"
              [(ngModel)]="family.data"  [filter]="true" placeholder="Select"
              [maxSelectedLabels]="0">
            </p-multiSelect>
          </div>
        </div>
        <!-- <table>
            <tbody>
                <tr *ngFor="let family of this.medicalHistoryUiEdit_data.others.data.family_history">
                    <td>
                        <p class="cust-select">{{family.name}}</p>
                    </td>
                    <td>
                        <p-multiSelect
                            [options]="this.medicalHistoryUiEdit_data.others.data.other_data.family_history_options_data"
                            [(ngModel)]="family.data" [filter]="true" placeholder="Select" class="ui-md-3"
                            [style]="{'width':'100%'}" maxSelectedLabels="3">
                        </p-multiSelect>
                    </td>
                </tr>

            </tbody>
        </table> -->
      </div>
    </div>
  </div>
</div>